import api from './client';

/**
 * Refresh DataForSEO metrics for a single backlink
 * @param {string} backlinkId - The backlink ID
 * @returns {Promise<{message: string, metrics: object}>}
 */
export async function refreshDFSMetrics(backlinkId) {
  const response = await api.post(`/api/backlinks/${backlinkId}/refresh-dfs`);
  return response.data;
}

/**
 * Batch refresh DataForSEO metrics for multiple backlinks
 * @param {string[]} backlinkIds - Array of backlink IDs
 * @param {string} [projectId] - Optional project ID to filter
 * @returns {Promise<{message: string, total: number, updated: number}>}
 */
export async function batchRefreshDFSMetrics(backlinkIds, projectId = null, onlyStale = false) {
  const response = await api.post('/api/backlinks/batch-refresh-dfs', {
    backlink_ids: backlinkIds,
    project_id: projectId,
    only_stale: onlyStale || undefined,
  });
  return response.data;
}

/**
 * Recalculate quality scores for all user's backlinks using latest formula
 */
export async function recalculateQualityScores() {
  const response = await api.post('/api/backlinks/recalculate-quality');
  return response.data;
}
